export const auth = {
errors: {
  deleteAccountFailed: "Ihr Konto wurde nicht gelöscht. Versuchen Sie es erneut.",
  workspacePreparing: "Ihr Arbeitsbereich wird noch eingerichtet. Warten Sie einen Moment und versuchen Sie es erneut.",
  signInAgain: "Melden Sie sich erneut an, um fortzufahren.",
  callbackCancelled: "Die Anmeldung wurde vor dem Abschluss abgebrochen. Versuchen Sie es erneut, wenn Sie bereit sind.",
  signInNotFinished: "Die Anmeldung wurde nicht abgeschlossen. Versuchen Sie es erneut.",
  signupUnavailable: "Wir können gerade keine Konten erstellen. Versuchen Sie es später erneut.",
  signupClosed: "Neue Konten gibt es derzeit nur auf Einladung. Verwenden Sie den Link aus Ihrer Einladungs-E-Mail oder melden Sie sich mit Ihrem bestehenden Konto an.",
  linkExpired: "Dieser Link ist abgelaufen oder wurde bereits verwendet. Fordern Sie einen neuen an.",
  emailInvalid: "Geben Sie eine gültige E-Mail-Adresse ein.",
  passwordTooCommon: "Dieses Passwort ist zu leicht zu erraten. Wählen Sie ein anderes.",
  passwordNeedsMix: "Verwenden Sie Groß- und Kleinbuchstaben, Ziffern und Sonderzeichen.",
  passwordTooShort: "Verwenden Sie mindestens {{n}} Zeichen.",
  samePassword: "Wählen Sie ein Passwort, das Sie noch nicht verwendet haben.",
  emailRateLimited: "Wir haben Ihnen gerade eine E-Mail gesendet. Warten Sie eine Minute, bevor Sie eine weitere anfordern.",
  rateLimited: "Zu viele Versuche. Warten Sie eine Minute und versuchen Sie es erneut.",
  alreadyRegistered: "Für diese E-Mail-Adresse gibt es schon ein Konto. Tippen Sie auf Anmelden oder auf Passwort vergessen?, wenn Sie ein neues Passwort brauchen.",
  emailNotConfirmed: "Bestätigen Sie zuerst Ihre E-Mail-Adresse. Öffnen Sie den Link, den wir Ihnen gesendet haben, und melden Sie sich dann an.",
  invalidCredentials: "E-Mail-Adresse und Passwort passen nicht zusammen. Prüfen Sie beides und versuchen Sie es erneut.",
  offline: "Sie sind offline. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  generic: "Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
},
session: {
  signIn: "Anmelden",
  renew: "Sitzung erneuern",
  expiredBody: "Tippen Sie auf Sitzung erneuern, um weiterzuarbeiten, oder auf Anmelden, um neu zu beginnen.",
  expiredTitle: "Ihre Sitzung ist abgelaufen",
},
appName: "AssetWRX",
social: {
  errorStartFailed: "Die Anmeldung wurde nicht gestartet. Versuchen Sie es erneut.",
  errorPopupTimeout: "Das Anmeldefenster hat zu lange gewartet und wurde geschlossen. Tippen Sie auf die Anmeldeschaltfläche, um neu zu beginnen.",
  errorPopupBlocked: "Ihr Browser hat das Anmeldefenster blockiert. Erlauben Sie Pop-ups für diese Seite und tippen Sie dann erneut auf die Anmeldeschaltfläche.",
continueWith: "oder weiter mit",
google: "Mit Google fortfahren",
apple: "Mit Apple fortfahren",
microsoft: "Mit Microsoft fortfahren",
signingIn: "Anmeldung wird geöffnet...",
errorSignInFailed: "Die Anmeldung wurde nicht abgeschlossen. Versuchen Sie es erneut.",
},
callback: {
  continueHere: "In diesem Browser fortfahren",
  appSignInHint: "Tippen Sie in der App auf Anmelden und verwenden Sie die E-Mail-Adresse und das Passwort, die Sie gerade gewählt haben.",
title: "Sie werden angemeldet",
body: "Einen Moment.",
successTitle: "Sie sind angemeldet",
successBody: "AssetWRX wird geöffnet …",
errorTitle: "Die Anmeldung wurde nicht abgeschlossen",
error: "Dieser Link ist abgelaufen oder wurde bereits verwendet. Tippen Sie auf Zurück zur Anmeldung und versuchen Sie es erneut.",
backToSignIn: "Zurück zur Anmeldung",
openInApp: "AssetWRX-App öffnen",
},
login: {
  biometricPasswordChanged: "Ihr Passwort wurde geändert, deshalb ist {{method}} ausgeschaltet. Melden Sie sich mit Ihrem neuen Passwort an und setzen Sie das Häkchen bei Beim nächsten Mal {{method}} verwenden.",
  title: "Bei AssetWRX anmelden",
showPassword: "Passwort anzeigen",
hidePassword: "Passwort ausblenden",
subtitle: "Melden Sie sich bei Ihrem Konto an",
email: "E-Mail",
password: "Passwort",
emailPlaceholder: "sie@beispiel.de",
passwordPlaceholder: "Ihr Passwort",
forgotPassword: "Passwort vergessen?",
signIn: "Anmelden",
signingIn: "Wird angemeldet...",
noAccount: "Noch kein Konto?",
createAccount: "Konto erstellen",
createAccountCta: "Neu hier? Konto erstellen",
orWithEmail: "oder mit E-Mail anmelden",
newHere: "Neu bei AssetWRX?",
createAccountLink: "Konto erstellen",
biometricUseNextTime: "Beim nächsten Mal {{method}} verwenden",
biometricSignIn: "Mit {{method}} anmelden",
biometricPrompt: "Bei AssetWRX anmelden",
biometricMethodFace: "Face ID",
biometricMethodFingerprint: "Fingerabdruck",
biometricMethodIris: "Iris",
biometricMethodGeneric: "Biometrie",
embedSsoHint: "Dieses Portal meldet Sie mit dem Microsoft-Konto Ihrer Organisation an.",
errorEmailRequired: "Bitte geben Sie Ihre E-Mail ein.",
errorEmailInvalid: "Geben Sie eine gültige E-Mail-Adresse ein.",
errorPasswordRequired: "Bitte geben Sie Ihr Passwort ein.",
errorLoginFailed: "Die Anmeldung hat nicht funktioniert. Prüfen Sie E-Mail-Adresse und Passwort und versuchen Sie es erneut.",
},
signup: {
  passwordHint: "Verwenden Sie mindestens {{n}} Zeichen.",
  useDifferentEmail: "Andere E-Mail-Adresse verwenden",
title: "Konto erstellen",
subtitle: "Treten Sie AssetWRX bei – dem Betriebssystem für Ihre physischen Anlagen.",
firstName: "Vorname",
firstNamePlaceholder: "Max",
lastName: "Nachname",
lastNamePlaceholder: "Mustermann",
role: "Rolle",
rolePlaceholder: "Betriebsleiter",
email: "E-Mail",
emailPlaceholder: "sie@beispiel.de",
password: "Passwort",
passwordPlaceholder: "Wählen Sie ein sicheres Passwort",
showPassword: "Passwort anzeigen",
hidePassword: "Passwort ausblenden",
confirmPassword: "Passwort bestätigen",
confirmPlaceholder: "Passwort erneut eingeben",
submit: "Konto erstellen",
signingUp: "Konto wird erstellt...",
hasAccount: "Bereits ein Konto?",
signInLink: "Anmelden",
emailInstead: "Stattdessen mit E-Mail registrieren",
emailInsteadHide: "E-Mail-Registrierung ausblenden",
useEmail: "Stattdessen E-Mail verwenden",
useEmailHide: "E-Mail-Registrierung ausblenden",
name: "Ihr Name",
namePlaceholder: "Alex Schmidt",
errorNameRequired: "Bitte geben Sie Ihren Namen ein.",
hasAccountShort: "Sie haben bereits ein Konto?",
errorFirstNameRequired: "Bitte geben Sie Ihren Vornamen ein.",
errorLastNameRequired: "Bitte geben Sie Ihren Nachnamen ein.",
errorRoleRequired: "Bitte geben Sie Ihre Rolle ein.",
errorEmailRequired: "Bitte geben Sie Ihre E-Mail ein.",
errorPasswordRequired: "Bitte geben Sie ein Passwort ein.",
errorPasswordMismatch: "Passwörter stimmen nicht überein.",
emailInvalid: "Geben Sie eine gültige E-Mail-Adresse ein.",
passwordsMatch: "Passwörter stimmen überein.",
passwordStrength: {
weak: "Schwach",
fair: "Mittel",
good: "Gut",
strong: "Stark",
},
errorSignUpFailed: "Ihr Konto wurde nicht erstellt. Versuchen Sie es erneut.",
errorLanguageInvalid: "Bitte wählen Sie eine unterstützte Sprache.",
errorTimezoneInvalid: "Bitte wählen Sie eine gültige Zeitzone.",
regionalSectionTitle: "Sprache, Zeitzone und Währung",
regionalSectionBody: "Diese Angaben gelten für Ihr Profil und Ihren neuen Arbeitsbereich. Sie können sie später in den Einstellungen ändern.",
languageLabel: "Sprache",
timezoneLabel: "Zeitzone",
currencyLabel: "Währung des Arbeitsbereichs",
currencyA11y: "Währung des Arbeitsbereichs {{code}}",
successCheckEmail: "Konto erstellt. Bitte prüfen Sie Ihre E-Mail zur Bestätigung und melden Sie sich dann an.",
successEmailTitle: "Prüfen Sie Ihren Posteingang",
successEmailBody: "Wir haben einen Link an {{email}} gesendet. Öffnen Sie ihn, um die Erstellung Ihres Kontos abzuschließen.",
resendConfirmation: "Link erneut senden",
resendingConfirmation: "Wird gesendet …",
resendSuccess: "Gesendet. Prüfen Sie Ihren Posteingang und den Spam-Ordner.",
resendError: "Der Link wurde nicht gesendet. Warten Sie eine Minute und tippen Sie dann auf Link erneut senden.",
consent: {
sectionTitle: "Bevor Sie fortfahren",
sectionBody: "Bitte lesen und akzeptieren Sie die untenstehenden Dokumente. Beide sind erforderlich, um Ihr Konto zu erstellen.",
acceptTerms: "Ich habe die <1>Nutzungsbedingungen</1> gelesen und akzeptiere sie.",
acceptPrivacy: "Ich habe die <1>Datenschutzerklärung</1> gelesen und akzeptiere sie.",
errorTermsRequired: "Bitte akzeptieren Sie die Nutzungsbedingungen, um fortzufahren.",
errorPrivacyRequired: "Bitte akzeptieren Sie die Datenschutzrichtlinie, um fortzufahren.",
a11yTermsCheckbox: "Nutzungsbedingungen akzeptieren",
a11yPrivacyCheckbox: "Datenschutzrichtlinie akzeptieren",
compactLead: "Ich akzeptiere:",
termsShort: "Bedingungen",
read: "Lesen",
privacyShort: "Datenschutz",
a11yReadTerms: "Nutzungsbedingungen lesen",
a11yReadPrivacy: "Datenschutzerklärung lesen",
shareUsage: "Nutzungsdaten teilen, um AssetWRX zu verbessern (optional)",
byContinuingBefore: "Mit dem Fortfahren akzeptieren Sie die ",
byContinuingBetween: " und die ",
byContinuingAfter: ".",
termsDoc: "Nutzungsbedingungen",
privacyDoc: "Datenschutzerklärung",
},
wizard: {
flowSubtitle: "Eine kurze geführte Einrichtung für Ihren Arbeitsbereich",
valueStrip: "Kostenlos starten. Keine Karte nötig.",
stepProgress: "Schritt {{current}} von {{total}}",
loadingDraft: "Ihr Fortschritt wird wiederhergestellt…",
welcomeBody: "Erstellen Sie Ihr Konto mit Google, Apple, Microsoft oder E-Mail. Neue Konten durchlaufen nach der Anmeldung eine kurze Einrichtung.",
continueWithEmail: "Mit E-Mail fortfahren",
back: "Zurück",
next: "Weiter",
yes: "Ja",
no: "Nein",
errorUseCaseRequired: "Bitte wählen Sie aus, wie Sie AssetWRX nutzen möchten.",
errorWorkspaceNameRequired: "Bitte geben Sie einen Namen für den Arbeitsbereich ein.",
errorStarterRequired: "Wählen Sie aus, was Sie zuerst tun möchten.",
useCaseTitle: "Hauptanwendungsfall",
useCaseBody: "Wählen Sie die Option, die am besten auf Sie zutrifft. Sie können dies später anpassen.",
useCases: {
field_inspections: "Orte oder Geräte prüfen",
asset_register: "Festhalten, was wir betreuen",
jobs_workorders: "Reparaturen und Aufträge organisieren",
team_collab: "Mit meinem Team arbeiten",
compliance_reporting: "Zertifikate und Vorschriften",
other: "Etwas anderes",
},
workspaceTitle: "Ihr Arbeitsbereich",
workspaceBody: "Dies ist Ihr Organisationsbereich in AssetWRX. Sie können ihn später in den Einstellungen umbenennen.",
workspaceNameLabel: "Name des Arbeitsbereichs",
workspaceNamePlaceholder: "z. B. Acme Facilities",
inviteOnlyNote: "Der Beitritt zum Team einer anderen Person ist nur auf Einladung möglich (nutzen Sie den Link aus Ihrer Einladungs-E-Mail).",
intentCreateTeam: "Ein Team in diesem Arbeitsbereich erstellen",
intentInviteMembers: "Teammitglieder nach der Einrichtung einladen",
starterTitle: "Was möchten Sie zuerst tun?",
starterBody: "Wir öffnen den passenden Bereich, nachdem Sie sich angemeldet und die Einrichtung abgeschlossen haben.",
starters: {
home: "Start-Dashboard öffnen",
asset: "Eine Anlage hinzufügen",
inspection: "Eine Prüfung starten",
schedule: "Eine Prüfung planen",
team: "Team & Einladungen verwalten",
},
reviewTitle: "Überprüfen & Konto erstellen",
reviewName: "Name: {{name}}",
reviewEmail: "E-Mail: {{email}}",
reviewWorkspace: "Arbeitsbereich: {{name}}",
reviewTeam: "Team erstellen: {{yes}}",
reviewInvites: "Mitglieder einladen: {{yes}}",
reviewEditHint: "Dieser Schritt zeigt nur eine Zusammenfassung. Um einen anderen Namen, eine andere E-Mail-Adresse oder ein anderes Passwort einzugeben, nutzen Sie die Schaltfläche unten (oder gehen Sie mit Zurück zu den vorherigen Seiten).",
reviewEditCta: "Name, E-Mail & Passwort bearbeiten",
},
},
firstRunSample: {
secondCheck: {
property: "Rauchmelder vorhanden und funktionsfähig?",
vehicle: "Beleuchtung und Reifen in Ordnung?",
equipment: "Schutzeinrichtungen und Warnhinweise vorhanden?",
other: "Sicherheitsausrüstung vorhanden und einsatzbereit?",
},
quickLook: {
templateName: "Kurzer Rundgang",
firstCheck: "Optischer Zustand in Ordnung?",
},
useCases: {
field_inspections: {
assetName: "Beispiel-Umwälzpumpe",
assetDescription: "Ein entfernbares Beispiel, um eine Inspektion vor Ort auszuprobieren.",
templateName: "Zustandskontrolle Pumpe",
firstCheck: "Gehäuse und Schutzeinrichtungen sicher?",
secondCheck: "Lecks, Geräusche oder Vibrationen?",
},
jobs_workorders: {
assetName: "Beispiel-Lüftungsgerät",
assetDescription: "Ein entfernbares Beispiel, um Wartungsarbeit zu finden und weiterzugeben.",
templateName: "Wartungsrundgang",
firstCheck: "Zugang und Trennstellen frei?",
secondCheck: "Ist Folgewartung nötig?",
},
compliance_reporting: {
assetName: "Beispiel-Brandschutzausrüstung",
assetDescription: "Ein entfernbares Beispiel, um nachweisgestützte Konformitätsprüfungen auszuprobieren.",
templateName: "Kontrolle der Konformitätsnachweise",
firstCheck: "Kennzeichnung und Zustand bestätigt?",
secondCheck: "Nachweis erfasst und gültig?",
},
asset_register: {
assetName: "Beispiel-Servicefahrzeug",
assetDescription: "Ein entfernbares Beispiel, das einen Anlagendatensatz im Betrieb zeigt.",
templateName: "Fahrzeug-Zustandskontrolle",
firstCheck: "Äußerer Zustand in Ordnung?",
secondCheck: "Sicherheitsausrüstung vorhanden und einsatzbereit?",
},
other: {
assetName: "Beispielgerät",
assetDescription: "Ein entfernbares Beispiel, um eine Inspektion und Folgearbeit auszuprobieren.",
templateName: "Kurze Betriebskontrolle",
},
},
},
postSignupOnboarding: {
industryTitle: "Was verwalten Sie?",
industryHint: "Wir fügen fertige Checklisten hinzu. Sie können sie später unter Checklisten ändern.",
industryChoices: {
property: "Immobilien",
fleet: "Fuhrpark",
equipment: "Ausrüstung",
facilities: "Gebäudetechnik",
mixed: "Gemischt oder etwas anderes",
},
title: "Richten Sie Ihren Arbeitsbereich ein",
subtitle: "Ein Name, zwei kurze Angaben und Sie sind drin.",
stepProgress: "Schritt {{current}} von {{total}}",
workspaceTitle: "Name des Arbeitsbereichs",
workspacePlaceholder: "Name Ihrer Organisation oder Ihres Teams",
workspaceHint: "Meist der Name Ihrer Firma oder Ihres Teams. Sie können ihn später ändern.",
useCaseTitle: "Wofür werden Sie AssetWRX nutzen?",
roleTitle: "Ihre Rolle",
teamTitle: "Team & Einladungen",
starterTitle: "Wohin soll es Sie zuerst führen?",
finish: "Weiter",
finishing: "Wird eingerichtet…",
deferNote: "Sprache, Währung und Team können Sie später unter Konto ändern.",
errorWorkspaceRequired: "Bitte geben Sie einen Arbeitsbereichsnamen ein.",
errorUseCaseRequired: "Bitte wählen Sie einen Haupt-Anwendungsfall.",
errorRoleRequired: "Bitte wählen Sie Ihre Rolle.",
errorSave: "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",
inviteNote: "Nach diesem Schritt können Sie Personen einladen.",
applyingTitle: "Ihre Auswahl wird übernommen",
applyingBody: "Ihr Arbeitsbereich wird eingerichtet. Einen Moment.",
languageTitle: "Sprache",
localeLineTitle: "Währung und Sprache",
localeChange: "Ändern",
localeDone: "Fertig",
languageHint: "Wählen Sie Ihre Sprache. Sie können sie später unter Konto ändern.",
currencyTitle: "Währung",
currencyHint: "Wählen Sie die Währung, mit der Sie arbeiten. Sie können sie später unter Konto ändern.",
},
firstActionChooser: {
title: "Womit möchten Sie anfangen?",
framing: "Fügen Sie etwas hinzu, das Sie betreuen, oder probieren Sie eine Übungsinspektion an einem Beispiel.",
framingTeam: "Laden Sie Ihre Kolleginnen und Kollegen ein, fügen Sie etwas hinzu, das Sie betreuen, oder probieren Sie eine Übungsinspektion.",
asset: {
title: "Meine erste Anlage hinzufügen",
subtitle: "Name und Typ genügen. Den Rest können Sie später ergänzen.",
},
sample: {
title: "Eine Übungsinspektion ausprobieren",
subtitle: "Wir legen eine Beispielanlage an, damit Sie sehen, wie eine Inspektion funktioniert. Sie können sie jederzeit entfernen.",
},
recommended: "Empfohlen",
reassure: "Sie können das Beispiel jederzeit entfernen.",
sampleErrorFallback: "Das Beispiel konnte nicht vorbereitet werden. Sie können stattdessen Ihre eigene Anlage hinzufügen.",
skip: "Zur Startseite",
team: {
title: "Team einrichten",
subtitle: "Legen Sie ein Team an und laden Sie Ihre Kolleginnen und Kollegen ein. Wir zeigen Ihnen jeden Schritt.",
subtitleLocked: "Teams gibt es in einem höheren Tarif. Tippen Sie, um zu sehen, welche Tarife es enthalten.",
},
},
forgot: {
  sentAgain: "Erneut gesendet. Prüfen Sie Ihren Posteingang und den Spam-Ordner.",
  spamHint: "Nichts erhalten? Prüfen Sie Ihren Spam-Ordner.",
  sendAgain: "Erneut senden",
title: "Passwort vergessen?",
subtitleEmail: "Geben Sie Ihre E-Mail-Adresse ein und tippen Sie auf Link senden. Wir senden Ihnen einen Link, um ein neues Passwort zu wählen.",
email: "E-Mail",
emailPlaceholder: "sie@beispiel.de",
sendLink: "Link senden",
sending: "Wird gesendet...",
backToSignIn: "Zurück zur Anmeldung",
sentTitle: "Prüfen Sie Ihre E-Mail",
sentBody: "Falls {{email}} ein Konto hat, haben wir einen Link zum Zurücksetzen gesendet. Öffnen Sie ihn und wählen Sie ein neues Passwort.",
errorEmailRequired: "Bitte geben Sie Ihre E-Mail ein.",
errorSendFailed: "Der Link wurde nicht gesendet. Warten Sie eine Minute und versuchen Sie es erneut.",
},
reset: {
  subtitleDoneApp: "Ihr Passwort wurde geändert. Tippen Sie auf Anmelden und verwenden Sie es.",
  sendNewLink: "Neuen Link senden",
  titleExpired: "Dieser Link ist abgelaufen",
title: "Neues Passwort festlegen",
titleDone: "Passwort aktualisiert",
subtitle: "Wählen Sie ein neues Passwort für Ihr Konto.",
subtitleNoSession: "Links zum Zurücksetzen funktionieren nur einmal und laufen nach einer Stunde ab. Tippen Sie auf Neuen Link senden, dann senden wir Ihnen einen neuen.",
subtitleForm: "Geben Sie Ihr neues Passwort zweimal ein und tippen Sie dann auf Passwort aktualisieren.",
subtitleDone: "Ihr Passwort wurde geändert. Kehren Sie zur AssetWRX-App zurück und melden Sie sich damit an.",
newPassword: "Neues Passwort",
confirmNewPassword: "Neues Passwort bestätigen",
confirmPassword: "Passwort bestätigen",
passwordPlaceholder: "Wählen Sie ein sicheres Passwort",
confirmPlaceholder: "Passwort erneut eingeben",
submit: "Passwort aktualisieren",
updating: "Wird aktualisiert...",
loading: "Wird geladen...",
success: "Passwort aktualisiert. Sie können sich jetzt anmelden.",
goToSignIn: "Anmelden",
backToSignIn: "Zurück zur Anmeldung",
errorTooShort: "Ihr neues Passwort ist zu kurz. Verwenden Sie mindestens {{n}} Zeichen.",
errorPasswordRequired: "Bitte geben Sie ein neues Passwort ein.",
errorMismatch: "Passwörter stimmen nicht überein.",
errorUpdateFailed: "Passwort konnte nicht aktualisiert werden.",
errorResetFailed: "Passwort konnte nicht zurückgesetzt werden.",
errorInvalidSession: "Dieser Link ist ungültig oder abgelaufen. Fordern Sie einen neuen auf der Anmeldeseite an.",
},
reconsent: {
  firstBody: "Lesen Sie die Nutzungsbedingungen und die Datenschutzerklärung, setzen Sie beide Häkchen und tippen Sie dann auf Akzeptieren und fortfahren.",
  firstTitle: "Akzeptieren Sie die Bedingungen, um fortzufahren",
errorMustAcceptBoth: "Beide Dokumente müssen akzeptiert werden, um fortfahren zu können.",
errorMustAcceptOne: "Das Dokument muss akzeptiert werden, um fortfahren zu können.",
errorSessionExpired: "Ihre Sitzung ist abgelaufen. Bitte wählen Sie „Ablehnen und abmelden“ und melden Sie sich dann erneut an, um fortzufahren.",
errorCouldNotRecord: "Ihre Annahme konnte nicht erfasst werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
unavailableTitle: "Ihre gespeicherte Annahme konnte nicht überprüft werden",
unavailableBody: "Stellen Sie eine Verbindung her und versuchen Sie erneut, zu prüfen, ob Dokumente überprüft werden müssen. Ihre gespeicherte Arbeit bleibt auf diesem Gerät.",
tryAgain: "Erneut versuchen",
continueOffline: "Fahren Sie vorerst offline fort",
signOut: "Abmelden",
needsConsentTitle: "Aktualisierte Bedingungen erfordern Ihre Zustimmung",
needsConsentBody: "Wir haben die folgenden Dokumente aktualisiert. Bitte überprüfen und akzeptieren Sie beide, um AssetWRX weiterhin verwenden zu können. Wenn Sie dies nicht akzeptieren, werden Sie abgemeldet. Sie können jedoch später immer noch die Löschung Ihres Kontos beantragen oder Ihre Daten exportieren.",
needsConsentBodyOne: "Wir haben das folgende Dokument aktualisiert. Bitte überprüfen und akzeptieren Sie es, um AssetWRX weiterhin verwenden zu können. Wenn Sie dies nicht akzeptieren, werden Sie abgemeldet. Sie können jedoch später immer noch die Löschung Ihres Kontos beantragen oder Ihre Daten exportieren.",
acceptTermsA11y: "Ich akzeptiere die Nutzungsbedingungen (v{{version}})",
acceptTermsLabel: "Ich akzeptiere die Nutzungsbedingungen (v{{version}}).",
readTermsA11y: "Lesen Sie die Nutzungsbedingungen",
readTerms: "Lesen Sie die Nutzungsbedingungen",
acceptPrivacyA11y: "Ich akzeptiere die Datenschutzrichtlinie (v{{version}})",
acceptPrivacyLabel: "Ich akzeptiere die Datenschutzerklärung (v{{version}}).",
readPrivacyA11y: "Datenschutzrichtlinie lesen",
readPrivacy: "Datenschutzrichtlinie lesen",
recording: "Wird gespeichert",
recordingEllipsis: "Wird gespeichert…",
acceptAndContinue: "Akzeptieren und fortfahren",
declineAndSignOut: "Ablehnen und abmelden",
},
guidedHub: {
  groupRule: {
    title: "Eine ganze Gruppe von Anlagen nach einem Zeitplan prüfen",
    subtitle: "Richten Sie eine Gruppenregel ein, etwa jede Brandschutztür jeden Monat.",
  },
  assistantActivity: {
    title: "Festlegen, wer über den Assistenten ändert",
    subtitle: "Änderungen über den Assistenten für Mitglieder ein- oder ausschalten.",
  },
  requestFeature: {
    title: "Eine Funktion wünschen",
    subtitle: "Sagen Sie dem AssetWRX-Team, was die App als Nächstes können soll.",
  },
  assetToursHint: "Weitere Anleitungen finden Sie bei jeder Anlage: öffnen, auf + tippen, dann Anleitung.",
  guide: {
    subtitle: "Schritt-für-Schritt-Hilfe für jeden Bereich der App.",
    title: "Benutzerhandbuch lesen",
  },
  invite: {
    subtitle: "Sie erhalten eine E-Mail und treten Ihrem Team bei.",
    title: "Kollegin oder Kollegen einladen",
  },
title: "Was möchten Sie tun?",
subtitle: "Wählen Sie eine Aufgabe. Wir markieren Schritt für Schritt, worauf Sie tippen.",
close: "Schließen",
groups: {
setup: "Richten Sie Ihren Arbeitsbereich ein",
reactive: "Teilen",
proactive: "Arbeit planen",
workspace: "Arbeitsbereich verwalten",
},
building: {
title: "Ein Gebäude einrichten",
subtitle: "Ein Gebäude, dann seine Etagen und Räume.",
},
asset: {
title: "Eine Anlage hinzufügen",
subtitle: "Ein Gebäude, Fahrzeug, eine Maschine oder alles, was Sie betreuen.",
},
site: {
title: "Standort hinzufügen",
subtitle: "Ein Ort, z. B. ein Gebäude oder Depot, an dem Anlagen sind.",
},
contractor: {
title: "Dienstleister hinzufügen",
subtitle: "Eine Person oder Firma, der Sie Arbeit geben.",
},
team: {
title: "Team erstellen",
subtitle: "Anlagen und Arbeit mit Kollegen teilen.",
},
requesters: {
title: "Eine Anlage teilen",
subtitle: "Jemanden eine Anlage sehen oder Arbeit dafür anfragen lassen.",
},
inspection: {
title: "Eine Prüfung planen",
subtitle: "Ein Besuch oder ein wiederkehrender.",
},
job: {
title: "Einen Auftrag anlegen",
subtitle: "Eine Reparatur oder Aufgabe und wer sie erledigt.",
},
maintenancePlan: {
title: "Richten Sie einen Wartungsplan ein",
subtitle: "Wiederkehrende Arbeit, z. B. eine jährliche Wartung.",
},
compliance: {
title: "Zertifikate und Vorschriften prüfen",
subtitle: "Sehen, was fehlt oder fällig ist, und es erledigen.",
},
industryPack: {
title: "Fertige Checklisten hinzufügen",
subtitle: "Checklisten für Ihre Branche.",
},
transferOwnership: {
title: "Team an neuen Eigentümer übergeben",
subtitle: "Erst wenn das Angebot angenommen wurde, ändert sich etwas.",
},
},
guidedJourney: {
  esg: {
    figures: {
      title: "Die wichtigsten Kennzahlen",
      body: "Jede Kennzahl der letzten 12 Monate mit ihrer Veränderung zum Vorjahr, aus den Zählerständen, die Sie bereits erfassen. Darunter das Diagramm und woher das CO₂ kommt.",
    },
    refrigerant: {
      title: "Kältemittel und F-Gase",
      body: "Das Gas kommt aus den Anlagendetails. Erfassen Sie die Füllmenge; die App berechnet die Tonnen CO2e, wie oft eine Dichtheitsprüfung nötig ist, und plant die Prüfung. Das Leckprotokoll listet jede Prüfung, jedes Leck und jede Nachfüllung.",
    },
    certificates: {
      title: "Energieausweise",
      body: "Ausweise werden einmal unter Dokumente abgelegt. Fügen Sie dort den EPC oder DEC hinzu, und die KI liest Klasse und Daten; diese Karte zeigt ihn mit „Ausweis öffnen“ und „Bearbeiten“.",
    },
    writeup: {
      title: "Zusammenfassen lassen",
      body: "Wählen Sie den Leser, und die KI schreibt eine kurze Zusammenfassung, die nur diese Zahlen verwendet, mit Schaltflächen für die vorgeschlagene Arbeit.",
      },
    },
  subJobs: {
    card: {
      title: "Die Teile dieses Auftrags",
      body: "Jeder Teilauftrag hat eigene Person oder Firma, Termin, Prüfungen und Fotos. Sie prüfen jeden; der ganze Auftrag wird einmal freigegeben.",
    },
    add: {
      title: "Tippen Sie auf Teilauftrag hinzufügen",
      body: "Beim ersten Mal sagen Sie, wer den Auftrag leitet. Dann geben Sie dem Teil einen Titel, wer ihn erledigt und wann. Mit Hinzufügen und weiter legen Sie mehrere nacheinander an.",
    },
  },
  visits: {
    add: {
      title: "Weiteren Besuch planen",
      body: "Wählen Sie Tag und Uhrzeit. Der Auftrag erscheint an jedem Besuchstag in Arbeit und im Kalender und wird einmal am Ende abgeschlossen.",
    },
  },
  groupRule: {
    add: {
      title: "Tippen Sie auf Gruppenregel hinzufügen",
      body: "Eine Gruppenregel legt eine Checkliste auf jede Anlage einer Gruppe, nach einem Zeitplan.",
    },
    which: {
      title: "Welche Anlagen",
      body: "Wählen Sie eine Art: Ort, Ausrüstung, Fahrzeug oder Sonstiges. Grenzen Sie dann auf eine Ortsart oder einen Ihrer Anlagentypen ein, etwa Brandschutztür.",
    },
    where: {
      title: "Wo",
      body: "Lassen Sie Überall stehen oder wählen Sie einen Ort wie Gebäude A, um nur das zu nehmen, was darin liegt. Eine Zone grenzt weiter ein.",
    },
    checklist: {
      title: "Checkliste wählen",
      body: "Jede Prüfung, die die Regel anlegt, nutzt diese Checkliste.",
    },
    howOften: {
      title: "Wie oft und ab wann",
      body: "Wählen Sie, wie oft, und das Datum der ersten Prüfung. Die nächste Prüfung jeder Anlage wird geplant, wenn die aktuelle erledigt ist.",
    },
    summary: {
      title: "Den Satz prüfen",
      body: "Die Regel wird in einem Satz zusammengefasst, mit der Zahl der Prüfungen, die beim Speichern entstehen.",
    },
    save: {
      title: "Regel speichern",
      body: "Tippen Sie auf Regel speichern. Die Prüfungen erscheinen auf der Seite Arbeit, und Anlagen, die später dazukommen, bekommen ihre eigene.",
    },
  },
  assistantActivity: {
    policy: {
      title: "Festlegen, wer Änderungen vornehmen darf",
      body: "Inhaber und Admins wählen: alle, nur Admins oder niemand. Bei niemand antwortet und berät der Assistent, ändert aber nichts.",
    },
    briefing: {
      title: "Ihr Wochenüberblick",
      body: "Schalten Sie den Wochenüberblick oben im Assistenten ein oder aus und schalten Sie vorgeschlagene Fragen wieder ein. Das ist Ihre eigene Einstellung.",
    },
    memory: {
      title: "Was sich der Assistent merkt",
      body: "Vorgaben für den ganzen Arbeitsbereich, an die sich der Assistent hält, etwa wie Sie Dinge nennen oder wer eine Art von Auftrag meist bekommt. Hier hinzufügen, ändern oder vergessen.",
    },
    list: {
      title: "Jede Änderung steht hier",
      body: "Was geändert wurde, von wem und wann, und ob es rückgängig gemacht wurde. Mitglieder sehen ihre eigenen.",
    },
  },
  requestFeature: {
    open: {
      title: "Auf Funktion wünschen tippen",
      body: "Sie finden es unter Hilfe, unter dem Benutzerhandbuch.",
    },
    what: {
      title: "Sagen Sie, was Sie möchten",
      body: "Ein kurzer Titel, dann wie es Ihnen helfen würde. Keine persönlichen oder Kundendaten.",
    },
    area: {
      title: "Teil der App wählen",
      body: "Wählen Sie, worum es geht. Sagen Sie auch, wie wichtig es ist, und fügen Sie bei Bedarf Bildschirmfotos hinzu.",
    },
    send: {
      title: "Absenden",
      body: "Tippen Sie auf Wunsch senden. Er geht an das AssetWRX-Team, und unter Ihre Wünsche sehen Sie Status und Antworten.",
    },
  },
  inMoreMenu: "Tippen Sie auf Mehr, um es zu finden.",
  myDay: {
    startNext: {
      body: "Tippen Sie auf „Nächsten starten“, um den Auftrag zu öffnen und zu beginnen.",
      title: "Nächsten Besuch starten",
    },
    share: {
      body: "Tippen Sie auf „Standort teilen“, damit Ihre Planung Verspätungen sieht. Oder auf Weiter.",
      title: "Standort teilen (optional)",
    },
    agenda: {
      body: "Ihre heutigen Besuche der Reihe nach, mit der Fahrt dazwischen. Tippen Sie auf Weiter.",
      title: "Das ist Ihr Tag",
    },
  },
  inPlusMenu: "Tippen Sie auf +, um es zu finden.",
next: "Weiter",
skipStep: "Schritt überspringen",
skip: "Anleitung beenden",
share: {
  confirm: {
    body: "Wählen Sie „Kann ansehen“ oder „Kann Arbeit anfragen“ und tippen Sie auf Teilen. Personen ohne Konto erhalten eine Einladung.",
    title: "Rechte festlegen",
  },
assetOpen: {
title: "Anlage öffnen",
body: "Tippen Sie auf die Anlage, die Sie teilen möchten.",
},
shareAction: {
title: "Mit einer Person teilen",
body: "Tippen Sie auf „Mit einer Person oder einem Team teilen“. Sie erhalten nur Zugriff auf diese Anlage.",
},
createContact: {
title: "Person auswählen",
body: "Tippen Sie auf einen Kontakt oder auf „Kontakt anlegen und verknüpfen“. Dann auf Weiter.",
},
},
inspection: {
pickAsset: {
title: "Anlage auswählen",
body: "Tippen Sie auf die Anlage, die Sie prüfen möchten.",
},
createChecklist: {
title: "Checkliste wählen",
body: "Behalten Sie diese Checkliste und tippen Sie auf Weiter, oder auf Ändern. Noch keine? Tippen Sie auf „Checkliste erstellen“.",
},
when: {
title: "Zeitpunkt wählen",
body: "Tippen Sie auf Jetzt, um sofort zu beginnen, oder auf Später für Datum und Uhrzeit.",
},
submit: {
title: "Starten",
body: "Tippen Sie auf „Inspektion starten“ (oder „Planen“ bei Später). Beantworten Sie jeden Punkt und tippen Sie auf „Inspektion abschließen“.",
},
},
job: {
pickAsset: {
title: "Anlage auswählen",
body: "Tippen Sie auf die Anlage, für die die Arbeit ist.",
},
title: {
title: "Beschreiben, was zu tun ist",
body: "Geben Sie einen kurzen Titel ein, z. B. Riemen tauschen, und wählen Sie, wer es macht.",
},
submit: {
title: "Auftrag anlegen",
body: "Tippen Sie auf „Auftrag anlegen“ (oder „Planen“ bei Später). Die zugewiesene Person wird informiert und nimmt an.",
},
},
proactive: {
when: {
title: "Auf Später tippen",
body: "Wählen Sie dann Tag und Uhrzeit der ersten Prüfung.",
},
recurrence: {
title: "Häufigkeit wählen",
body: "Tippen Sie unter Wiederholen, wie oft es wiederkommt, z. B. Jeden Monat.",
},
submit: {
title: "Planen",
body: "Tippen Sie auf „Inspektion planen“. Jede Prüfung erscheint an ihrem Tag unter Arbeit; tippen Sie in der Meldung auf Öffnen.",
},
},
addSite: {
name: {
title: "Standort benennen",
body: "Geben Sie den Namen ein, den Ihr Team nutzt, z. B. Depot Nord.",
},
location: {
title: "Adresse (optional)",
body: "Geben Sie die Adresse ein und wählen Sie sie aus der Liste. Oder tippen Sie auf Weiter.",
},
classify: {
title: "Art des Standorts (optional)",
body: "Wählen Sie die Art des Ortes und den Status. Oder tippen Sie auf Weiter.",
},
structure: {
title: "Übergeordneter Standort und Team (optional)",
body: "Ordnen Sie ihn einem größeren Standort zu oder wählen Sie das zuständige Team. Oder tippen Sie auf Weiter.",
},
create: {
title: "Standort anlegen",
body: "Tippen Sie auf „Standort anlegen“. Der Standort öffnet sich, bereit für seine Anlagen.",
},
},
addAssetsToSite: {
assign: {
title: "Anlagen zu diesem Standort hinzufügen",
body: "Tippen Sie auf Zuweisen und wählen Sie die Anlage. Eine Meldung bestätigt den Umzug.",
},
},
addContractor: {
name: {
title: "Namen eingeben",
body: "Geben Sie den Namen der Person oder Firma ein.",
},
contact: {
title: "E-Mail eingeben",
body: "Eine Firma braucht eine E-Mail: Einladungen gehen dorthin.",
},
save: {
title: "Hinzufügen",
body: "Tippen Sie auf „Kontakt hinzufügen“. Um Arbeit zu geben, öffnen Sie einen Auftrag und tippen auf Zuweisen.",
},
},
raiseRequest: {
  summary: {
    body: "Geben Sie eine kurze Zusammenfassung ein, z. B. Tropfender Wasserhahn in der Küche.",
    title: "Beschreiben, was los ist",
  },
outcome: {
title: "Was brauchen Sie?",
body: "Wählen Sie: Nur Hilfe, Ein Auftrag oder Eine Inspektion.",
},
submit: {
title: "Absenden",
body: "Tippen Sie auf Senden. Ein Auftrag oder eine Inspektion öffnet sich ausgefüllt; sonst wartet es unter Arbeit.",
},
},
shareReport: {
contact: {
title: "Empfänger wählen",
body: "Tippen Sie auf „Kontakt auswählen“ und wählen Sie die Person.",
},
role: {
title: "Rolle prüfen",
body: "Die Beziehung kommt aus dem Kontakt. Tippen Sie nur auf Ändern, wenn sie falsch ist, sonst auf Weiter.",
},
send: {
title: "Senden",
body: "Tippen Sie auf „Bericht senden“. Die Person erhält eine E-Mail mit Link, und Sie werden bei Antwort informiert.",
},
},
planADay: {
  apply: {
    body: "Erst mit Übernehmen wird gespeichert. Dann bestätigt jede Person ihren Tag.",
    title: "Mit Übernehmen speichern",
  },
  optimise: {
    body: "Tippen Sie auf „Plan vorschlagen“, um den Tag mit möglichst wenig Fahrt zu füllen. Tippen Sie bei jeder Änderung, die Sie nicht möchten, auf ×.",
    title: "Oder Vorschlag holen",
  },
  panel: {
    body: "Wählen Sie Person, Tag und Startzeit. Es bleibt gestrichelt, bis Sie auf Übernehmen tippen.",
    title: "Wer und wann",
  },
  unplanned: {
    body: "Hier steht Arbeit ohne Zeit oder ohne Person. Tippen Sie auf einen Eintrag, um ihn zu planen.",
    title: "Mit „Ungeplant“ beginnen",
  },
  },
convertRequest: {
approve: {
title: "Anfrage genehmigen",
body: "Tippen Sie auf Genehmigen und zum Bestätigen noch einmal. Die anfragende Person wird informiert.",
},
convert: {
title: "In Arbeit umwandeln",
body: "Tippen Sie auf „Auftrag anlegen“ oder Prüfen. Die Angaben sind ausgefüllt; Sie wählen, wer und wann.",
},
},
addDocument: {
  title: {
    body: "Geben Sie einen klaren Namen ein, z. B. Gasprüfung 2026.",
    title: "Titel eingeben",
  },
type: {
title: "Dokumentart wählen",
body: "Wählen Sie unter Dokumentart Zertifikat, Garantie, Vorschrift oder Allgemein.",
},
save: {
title: "Datei hinzufügen und speichern",
body: "Hängen Sie die Datei an, ergänzen Sie ggf. das Ablaufdatum und tippen Sie auf „Dokument speichern“.",
},
},
assignAssetTeam: {
change: {
title: "Auf Ändern tippen",
body: "Tippen Sie neben „Verantwortliches Team“ auf Ändern.",
},
pick: {
title: "Team wählen",
body: "Tippen Sie auf das Team. Eine Meldung bestätigt, wer es jetzt sieht.",
},
},
addTeam: {
open: {
title: "Auf „Team anlegen“ tippen",
body: "Ein Team teilt Anlagen und Arbeit mit eingeladenen Personen. Schon eins? Tippen Sie auf Neues Team.",
},
name: {
title: "Team benennen",
body: "Wählen Sie einen Namen, den Ihre Kollegen erkennen.",
},
submit: {
title: "Anlegen",
body: "Tippen Sie auf „Team anlegen“. Danach öffnet sich die Einladung.",
},
},
inviteMembers: {
open: {
title: "Auf „Personen einladen“ tippen",
body: "Laden Sie eine Kollegin oder einen Kollegen ins Team ein.",
},
email: {
title: "E-Mail eingeben",
body: "Geben Sie die E-Mail-Adresse ein, eine pro Zeile, und wählen Sie Mitglied oder Admin.",
},
send: {
title: "Einladung senden",
body: "Tippen Sie auf „Einladung senden“. Die Person erhält eine E-Mail und erscheint nach Annahme unter Mitglieder.",
},
},
assignContractor: {
open: {
title: "Auf Zuweisen tippen",
body: "Wählen Sie Kollegin, Kollegen oder Firma. Firmen brauchen eine E-Mail, um informiert zu werden.",
},
},
aiReport: {
reader: {
title: "Für wen ist er?",
body: "Wählen Sie den Leser. Dieselben Fakten werden in der Reihenfolge erzählt, die diesem Leser wichtig ist. Oder tippen Sie auf Weiter.",
},
analyses: {
title: "Inhalte wählen",
body: "Alle Themen sind an. Tippen Sie auf eines, um es wegzulassen, oder auf Weiter.",
},
generate: {
title: "Bericht erstellen",
body: "Prüfen Sie die Kosten und tippen Sie dann auf „KI-Fassung schreiben“. Sie werden benachrichtigt, sobald er fertig ist, und erst dann werden Credits verbraucht.",
},
},
relateAsset: {
search: {
title: "Andere Anlage suchen",
body: "Suchen Sie die andere Anlage und tippen Sie darauf.",
},
save: {
title: "Verknüpfung speichern",
body: "Wählen Sie die Art der Beziehung und tippen Sie auf „Beziehung hinzufügen“.",
},
},
publicIntake: {
share: {
title: "Auf Teilen tippen",
body: "Meldungen per QR-Code richten Sie unter Teilen ein.",
},
choose: {
title: "Jeden Probleme melden lassen",
body: "Tippen Sie auf „Jeden mit dem Code Probleme melden lassen“. Kein Konto nötig.",
},
enable: {
title: "Einschalten",
body: "Schalten Sie den Schalter ein. Code und Link erscheinen darunter.",
},
copy: {
title: "Link teilen",
body: "Tippen Sie auf „Link kopieren“ (oder am Computer „QR drucken“) und hängen Sie es gut sichtbar auf.",
},
},
setUpBuilding: {
name: {
title: "Gebäude benennen",
body: "Geben Sie den gebräuchlichen Namen ein, z. B. Gebäude A oder Nordturm.",
},
type: {
title: "Es ist ein Ort",
body: "Ort ist bereits gewählt. Etagen, Räume, Parkplätze und andere Bereiche sind ebenfalls Orte.",
},
placeType: {
title: "Auf Gebäude tippen",
body: "Geben Sie an, welche Art von Ort es ist. Wählen Sie hier Gebäude; später wählen Sie Etage oder Raum für das, was darin liegt.",
},
save: {
title: "Erstellen",
body: "Tippen Sie auf Anlage erstellen. Danach öffnet sich das Gebäude.",
},
addInside: {
title: "Etagen hinzufügen",
body: "Tippen Sie auf „Ort darin hinzufügen“, um Etage 1 anzulegen. Jede Etage hat dieselbe Schaltfläche für ihre Räume und „Ausrüstung hier hinzufügen“ für das, was dort eingebaut ist.",
},
},
addAsset: {
name: {
title: "Benennen",
body: "Geben Sie den Namen ein, den Ihr Team nutzt, z. B. Kessel 3 oder Eichenweg 14.",
},
type: {
title: "Typ wählen",
body: "Tippen Sie auf Ort, Ausrüstung, Fahrzeug oder Sonstiges. Ein Ort ist ein Gebäude, eine Etage, ein Raum oder ein anderer Bereich. Erscheint „Sieht aus wie“, tippen Sie auf Übernehmen.",
},
location: {
title: "Wo ist sie? (optional)",
body: "Fügen Sie Standort oder Adresse hinzu. Oder tippen Sie auf Weiter.",
},
identify: {
title: "Foto und Seriennummer (optional)",
body: "Fügen Sie ein Foto und die Nummer vom Typenschild hinzu. Oder tippen Sie auf Weiter.",
},
details: {
title: "Weitere Angaben (optional)",
body: "Hersteller, Modell und wichtige Daten jetzt oder später. Oder tippen Sie auf Weiter.",
},
save: {
title: "Anlegen",
body: "Tippen Sie auf „Anlage anlegen“. Sie öffnet sich danach, bereit zur Prüfung.",
},
},
decommission: {
options: {
title: "Menü ⋯ öffnen",
body: "Tippen Sie oben bei der Anlage auf ⋯.",
},
status: {
  title: "Auf Status ändern tippen",
  body: "Inbetriebnahme, Außerbetriebnahme, Ausmusterung und Wiederherstellung finden Sie hier.",
},
choose: {
title: "Auf „Außer Betrieb nehmen“ tippen",
body: "Die Anlage behält ihren Verlauf. Routinearbeit stoppt, bis sie wieder in Betrieb ist.",
},
reason: {
title: "Grund wählen",
body: "Wählen Sie, warum sie außer Betrieb geht. Das wird gespeichert.",
},
confirm: {
title: "Bestätigen",
body: "Tippen Sie auf „Sicherungsauftrag anlegen“ oder schalten Sie das aus und tippen Sie auf „Jetzt außer Betrieb nehmen“.",
},
},
commission: {
start: {
title: "Auf In Betrieb nehmen tippen",
body: "Tippen Sie im Hinweis auf „In Betrieb nehmen“.",
},
inspect: {
title: "Inspektion starten",
body: "Tippen Sie auf „Inspektion starten“. Wenn sie und ihre Aufträge erledigt sind, tippen Sie auf „Wieder in Betrieb“.",
},
},
retire: {
options: {
title: "Menü ⋯ öffnen",
body: "Tippen Sie oben bei der Anlage auf ⋯.",
},
status: {
  title: "Auf Status ändern tippen",
  body: "Inbetriebnahme, Außerbetriebnahme, Ausmusterung und Wiederherstellung finden Sie hier.",
},
choose: {
title: "Auf „Anlage ausmustern“ tippen",
body: "Nur eine Anlage außer Betrieb kann ausgemustert werden. Sonst wird zuerst „Außer Betrieb nehmen“ angeboten.",
},
reason: {
title: "Grund angeben",
body: "Wählen Sie den Grund. Bei Verkauf oder Verschrottung: an wen.",
},
confirm: {
title: "Zum Bestätigen AUSMUSTERN eingeben",
body: "Geben Sie AUSMUSTERN ein und tippen Sie auf „Diese Anlage ausmustern“. Eigentümer oder Admins können sie wiederherstellen.",
},
},
meterReading: {
value: {
title: "Zählerstand eingeben",
body: "Geben Sie die Zahl auf dem Zähler ein. Am Handy können Sie stattdessen ein Foto hinzufügen, und die App liest den Wert ab.",
},
save: {
title: "Speichern",
body: "Tippen Sie auf „Zählerstand speichern“. Pläne nach Kilometern oder Stunden zählen ab dieser Zahl.",
},
},
maintenancePlan: {
  asset: {
    body: "Tippen Sie auf Anlage und wählen Sie, wofür der Plan ist. Schon gewählt? Tippen Sie auf Weiter.",
    title: "Anlage wählen",
  },
title: {
title: "Arbeit beschreiben",
body: "Geben Sie unter „Was wird gemacht“ die Arbeit ein, z. B. Jahreswartung.",
},
cadence: {
title: "Häufigkeit wählen",
body: "Unter „Wann ist es fällig?“ Wiederholt sich lassen und „Alle 12 Monate“ wählen, oder „Nach Zählerstand“ einschalten. Dann Weiter.",
},
save: {
title: "Plan anlegen",
body: "Wählen Sie unter „Ausführen als“ Auftrag oder Inspektion und tippen Sie auf „Plan anlegen“. Eine Meldung nennt den ersten Termin unter Arbeit.",
},
},
addKnowledge: {
kind: {
title: "Art wählen",
body: "Wählen Sie Notiz, FAQ, Anleitung, Link oder Datei.",
},
title: {
title: "Titel vergeben",
body: "Nutzen Sie Suchbegriffe, z. B. Kessel zurücksetzen. Dann schreiben oder diktieren.",
},
save: {
title: "Speichern",
body: "Tippen Sie auf Speichern. Alle, die an der Anlage arbeiten, finden es.",
},
},
moveAsset: {
reason: {
title: "Umgezogen oder Korrektur?",
body: "Tippen Sie auf „Wurde bewegt“ oder „War falsch“.",
},
location: {
title: "Wo ist sie jetzt?",
body: "Suchen Sie die Adresse oder nutzen Sie Ihren Standort.",
},
submit: {
title: "Umzug speichern",
body: "Tippen Sie auf „Umzug speichern“ oder „Ort korrigieren“. Der alte Ort bleibt im Verlauf.",
},
},
complianceRegister: {
refine: {
title: "Finden, was Sie brauchen (optional)",
body: "Suchen Sie nach Namen oder tippen Sie auf Filtern. Dann auf Weiter.",
},
row: {
title: "Eine Zeile erledigen",
body: "Jede Zeile zeigt, was fehlt oder fällig ist. Tippen Sie auf ihren Button, z. B. Erneuern.",
},
},
industryPack: {
install: {
title: "Paket installieren",
body: "Tippen Sie bei Ihrer Branche auf „Paket installieren“. Die Checklisten erscheinen unter Checklisten.",
},
},
transferOwnership: {
open: {
title: "Auf „Eigentum übertragen“ tippen",
body: "Unter Team-Einstellungen. Nur der Eigentümer sieht es, sobald es ein weiteres Mitglied gibt.",
},
member: {
title: "Neuen Eigentümer wählen",
body: "Wählen Sie ein Mitglied. Erst nach dessen Zustimmung ändert sich etwas; dann sind Sie Admin.",
},
},
},
mfa: {
  codeNotValid: "Dieser Code hat nicht funktioniert. Codes ändern sich alle 30 Sekunden – öffnen Sie Ihre Authentifizierungs-App und geben Sie den neuesten ein.",
invalidCode: "Dieser Code war ungültig. Prüfen Sie Ihre Authenticator-App und versuchen Sie es erneut.",
enterCode: "6-stelligen Code eingeben",
verifying: "Wird überprüft…",
verifyCta: "Prüfen und aktivieren",
challenge: {
  contactSupport: "AssetWRX-Support kontaktieren",
pageTitle: "Zwei-Faktor-Bestätigung",
title: "Bestätigungscode eingeben",
body: "Öffnen Sie Ihre Authenticator-App und geben Sie den 6-stelligen Code für AssetWRX ein.",
backA11y: "Anmeldung abbrechen und zurückgehen",
back: "Zurück",
loadError: "Ihre Zwei-Faktor-Methode konnte nicht geladen werden. Melden Sie sich erneut an.",
resetSent_one: "Wir haben Ihren Arbeitsbereich-Admin informiert. Er kann Ihre Zwei-Faktor-Anmeldung zurücksetzen, damit Sie sie neu einrichten können.",
resetSent_other: "Wir haben Ihre Arbeitsbereich-Admins informiert. Sie können Ihre Zwei-Faktor-Anmeldung zurücksetzen, damit Sie sie neu einrichten können.",
resetNoAdmin: "Sie sind Inhaber des Arbeitsbereichs, daher kann niemand über Ihnen dies zurücksetzen. Melden Sie sich auf einem Gerät an, das Ihre Authentifizierungs-App noch hat, oder kontaktieren Sie unten den AssetWRX-Support.",
resetError: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
verifyCta: "Überprüfen",
lostDevice: "Gerät verloren? Bitten Sie einen Arbeitsbereich-Admin, Ihre Zwei-Faktor-Einrichtung zurückzusetzen, oder melden Sie sich ab.",
requestReset: "Zurücksetzen beim Admin anfragen",
requesting: "Wird gesendet…",
signOut: "Abmelden",
},
enroll: {
  otherPhoneQr: "Anderes Telefon? Scannen Sie diesen Code.",
  step2SameDevice: "Tippen Sie auf Authentifizierungs-App öffnen, fügen Sie das Konto hinzu und kehren Sie dann hierher zurück",
  a11yGooglePlay: "{{app}}: bei Google Play laden",
  a11yAppStore: "{{app}}: im App Store laden",
  appBlurb: "Kostenlos. Funktioniert auf iPhone und Android.",
backA11y: "Zurück",
back: "Zurück",
title: "Zwei-Faktor-Anmeldung einrichten",
lead: "Das fügt der Anmeldung einen zweiten Schritt hinzu, damit nur Sie hineinkommen — selbst wenn jemand Ihr Passwort kennt. Es dauert etwa eine Minute.",
startError: "Die Einrichtung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
step1: "Laden Sie eine kostenlose Authenticator-App auf Ihr Telefon",
step1Hint: "Schon vorhanden? Weiter mit Schritt 2.",
appStore: "iPhone",
googlePlay: "Android",
step2: "Tippen Sie in der App auf „＋“ und scannen Sie diesen Code",
qrAlt: "Zwei-Faktor-QR-Code",
manualLabel: "Scannen nicht möglich? Geben Sie diesen Schlüssel manuell ein:",
copySecret: "Einrichtungsschlüssel kopieren",
openApp: "Authentifizierungs-App öffnen",
step3: "Geben Sie den 6-stelligen Code aus der App ein",
preparing: "Einrichtung wird vorbereitet…",
backupTitle: "Sicherheitshalber ein Backup hinzufügen",
backupBody: "Zwei-Faktor ist aktiv. Falls Sie Ihren Authenticator einmal verlieren, ist ein zweiter auf einem anderen Gerät der schnellste Weg zurück. Empfohlen.",
addBackup: "Fügen Sie einen Backup-Authentifikator hinzu",
finish: "Fertig",
backupSetupTitle: "Backup-Authenticator hinzufügen",
backupSetupBody: "Scannen Sie dies mit Ihrer zweiten Authenticator-App und geben Sie dann den angezeigten 6-stelligen Code ein.",
skipBackup: "Vorerst überspringen",
},
gate: {
challengeTitle: "Bestätigen Sie, dass Sie es sind",
blockedTitle: "Zwei-Faktor-Anmeldung ist erforderlich",
nagTitle: "Zwei-Faktor-Anmeldung aktivieren",
challengeBody: "Geben Sie Ihren Authenticator-Code ein, um fortzufahren.",
blockedBody: "Richten Sie zum Schutz Ihres Kontos eine Authenticator-App ein, um fortzufahren.",
nagBody: "Fügen Sie eine Authenticator-App hinzu für deutlich mehr Sicherheit — es dauert nur eine Minute.",
nagBodyDated: "Die Zwei-Faktor-Anmeldung wird am {{dateLabel}} verpflichtend. Richten Sie sie jetzt ein — es dauert nur eine Minute.",
verifyCta: "Code eingeben",
setupCta: "Zwei-Faktor einrichten",
signOut: "Abmelden",
later: "Später erinnern",
},
},
};
